"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = void 0;
const themes_1 = require("../../themes");
const index_1 = require("../index");
const react_1 = __importDefault(require("react"));
const ButtonGroup_1 = __importDefault(require("@mui/material/ButtonGroup"));
const ButtonGroup = ({ value: selected, onChange, options, ButtonProps = {}, squared, }) => {
    const theme = (0, themes_1.useTheme)();
    const borderRadius = squared ? theme.spacing(0.5) : undefined;
    const style = (isSelected) => ({
        color: isSelected ? theme.palette.primary.main : 'grey.600',
        border: '1px solid',
        borderColor: 'rgba(0, 0, 0, 0.54)',
        '&:first-of-type': {
            borderTopLeftRadius: borderRadius,
            borderBottomLeftRadius: borderRadius,
        },
        '&:last-of-type': {
            borderTopRightRadius: borderRadius,
            borderBottomRightRadius: borderRadius,
        },
        ...ButtonProps.sx,
    });
    return (react_1.default.createElement(ButtonGroup_1.default, { disableElevation: true }, options.map(({ value, label, disabled }) => {
        const isSelected = selected.some((o) => o.value === value);
        return (react_1.default.createElement(index_1.Button, { sx: style(isSelected), variant: isSelected ? 'contained' : 'muted', color: isSelected ? 'secondary' : undefined, disabled: disabled, key: value?.toString(), onClick: () => onChange(value), ...ButtonProps }, label));
    })));
};
exports.ButtonGroup = ButtonGroup;
exports.default = exports.ButtonGroup;
